<template>
  <div class="sku-info">
    <template v-if="showSkuFormat">
      <div class="sku-all-formate">
        <tag
          v-for="(item, index) in sku.skuFormats.skuAllFormat"
          :key="index"
          has-background
          :secondary-color="'#F5F5F5'"
          :font-size="11"
          :primary-color="'#262626'"
          :corner-radius="4"
          padding="2"
          :tag-style="tagStyle"
        >
          {{ item }}
        </tag>
      </div>
      <div class="price-wrapper">
        <div v-if="!!sku.skuPrice.priceShield" class="no-login">
          {{ sku.skuPrice.priceShieldText }}
        </div>
        <div v-if="!isOpen && !sku.skuPrice.priceShield" class="sale-price">
          <span class="prefix">{{ goodPrice.prefix }}</span>
          <span class="value">{{ goodPrice.price }}</span>
          <span class="unit">/{{ goodPrice.unit }}</span>
        </div>
        <OpenSsuBtn
          :is-open="isOpen"
          :bg-start-color="'#37DF7E'"
          :bg-end-color="'#15BB5C'"
          class="open-ssu-btn"
          @openChange="openChange"
        />
      </div>
      <div v-if="!isOpen" class="good-tag-wrap">
        <GoodTag :good-tags="tagList" />
      </div>
    </template>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
import OpenSsuBtn from '@/common/widgets/open_ssu_btn/index.vue'
import GoodTag from '@/common/cms/modules/goods/template/widgets/new-good-tag.vue'
export default {
  components: {
    Tag,
    OpenSsuBtn,
    GoodTag
  },
  props: {
    sku: {
      type: Object,
      default: () => ({})
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tagStyle: {
        padding: '.04rem',
        flex: 'none',
        marginRight: '.08rem'
      }
    }
  },
  computed: {
    showSkuFormat() {
      return this.sku.skuFormats?.skuAllFormat?.length > 0
    },
    goodPrice() {
      const approximateShow = this.sku.skuPrice.isShowWeightUnitPrice === 1
      let price
      if (approximateShow) {
        price = this.sku.skuPrice.minWeightPrice
        if (
          this.sku.skuPrice.minWeightPrice !== this.sku.skuPrice.maxWeightPrice
        ) {
          price += '-' + this.sku.skuPrice.maxWeightPrice
        }
      } else {
        price = this.sku.skuPrice.minPrice
        if (this.sku.skuPrice.minPrice !== this.sku.skuPrice.maxPrice) {
          price += '-' + this.sku.skuPrice.maxPrice
        }
      }

      return {
        prefix: approximateShow ? '约￥' : '￥',
        price,
        unit: this.sku.skuPrice[
          approximateShow ? 'weightPriceUnit' : 'priceUnit'
        ]
      }
    },
    tagList() {
      const taglist = [
        ...(this.sku.skuTags?.operateTags || []),
        ...(this.sku.skuTags?.ownerTags || []),
        ...(this.sku.skuTags?.promotionTags || [])
      ]
      return taglist
    }
  },
  methods: {
    openChange(value) {
      this.$emit('openChange', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.sku-info {
  @include text(0.3rem, #262626, bold);
  @include text-overflow-ellipsis-single;
  .sku-all-formate {
    margin-top: 0.08rem;
    @include flex-row-wrap;
  }

  .price-wrapper {
    position: relative;

    height: 0.5rem;

    @include flex-row-between;

    .no-login {
      margin-top: 0.1rem;

      font-size: 0.32rem;
      font-weight: 500;
      color: #f03100;
    }
    .sale-price {
      display: inline-block;

      width: 0;

      flex: auto;

      font-weight: bold;
      white-space: nowrap;

      color: #f03100;
      .prefix {
        font-size: 0.24rem;
      }
      .value {
        font-size: 0.44rem;
      }
      .unit {
        font-size: 0.26rem;
      }
    }
  }
  .good-tag-wrap {
    margin-top: 0.08rem;
  }
  .open-ssu-btn {
    position: absolute;
    right: 0;

    background-color: #fff;
  }
}
</style>
